import { Col, Row } from "react-bootstrap"
import ShowImagePanel from "./ShowImagePanels"
import { Link } from "react-router"

export default function CategoryPanel100({ content, path }: any) {
    return (
        <Col xs={12}>
            <Row className="rounded-4 m-1 my-2 p-3 shadow border-2 border border-warning warrningGradientYellowToWhiteEven">
                <Col xs={6} md={4} className="pe-4 text-end">
                    <h2 className="fs-1 fw-bolder text-dark">{content.categoryName}</h2>
                    <div className="text-black-50 d-none d-xl-block">
                        Mamy w tej kategorii
                        <span className="fw-bolder"> {content?.productsQuantity} </span>
                        produktów
                    </div>
                    <Link to={path} className='btn btn-success fw-bold mt-3 mb-2'>
                        Zobacz więcej w kategorii
                        <i className="bi bi-caret-right-fill" />
                    </Link>
                    {/* TODO: Linki Polecamy */}
                    <Link to={path} className="btn btn-danger fw-bold">
                        Polecamy
                        <span className="bi bi-caret-right-fill"></span>
                    </Link>
                </Col>
                <Col xs={6} md={8} className="row align-items-center d-md-none">
                    <ShowImagePanel content={content} maxImages={1} />
                </Col>
                <Col xs={6} md={8} className="row align-items-center d-none d-md-flex">
                    <ShowImagePanel content={content} maxImages={3} />
                </Col>
            </Row>
        </Col>
    )
}